<template>
  <v-card class="card-pad mx-auto" width="900px">
    <v-dialog v-model="alterDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{ $t('Os dados informados não serão salvos, deseja continuar?') }}
          </div>

          <v-btn
            :disabled="loading"
            class="ma-1"
            color="grey"
            text
            @click="alterDialog = false"
          >
            {{ $t('Não') }}
          </v-btn>

          <v-btn
            depressed
            :loading="loading"
            class="ma-1"
            color="#B14949"
            text
            @click="closeDialog"
          >
            {{ $t('Sim') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <v-btn absolute top right depressed dark icon @click="close">
      <v-icon color="#bbb">mdi-close</v-icon>
    </v-btn>

    <div class="d-flex justify-center my-3">
      <h2>{{ $t(title) }}</h2>
    </div>

    <span class="main-subtitle ml-6">{{ $t(currentTitle) }}</span>

    <v-divider class="ma-6 my-2"></v-divider>

    <v-window v-model="step" touchless>
      <v-window-item :value="0">
        <v-form
          class="form"
          ref="firstForm"
          v-model="firstValid"
          lazy-validation
          :disabled="institutionInactive"
        >
          <v-row class="ma-0" dense v-show="institutionInactive">
            <v-col class="py-0" cols="12">
              <InstitutionInactive />
            </v-col>
          </v-row>
          <v-row class="ma-0 mx-6" dense>
            <v-col cols="12" sm="6" md="6" lg="6" class="pb-0">
              <label class="label">{{ $t('Fornecedor') }}</label>
              <v-text-field
                hide-details="auto"
                v-model="currentSupplier.name"
                :rules="nameRules"
                required
                outlined
                class="primary-input"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="6" class="pb-0">
              <label class="label">{{ $t('Razão social') }}</label>
              <v-text-field
                hide-details="auto"
                v-model="currentSupplier.corporateName"
                :rules="corporateNameRules"
                required
                outlined
                class="primary-input"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="6" class="pb-0">
              <label class="label">{{ $t('CNPJ') }}</label>
              <v-text-field
                hide-details="auto"
                v-model="currentSupplier.cnpj"
                :rules="[
                  (v) => !!v || 'CNPJ é requerido',
                  (v) => this.validarCNPJ(v) || 'Cnpj Inválido',
                ]"
                v-mask="['##.###.###/####-##']"
                required
                outlined
                class="primary-input"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="6" class="pb-0">
              <label class="label">{{ $t('Website') }}</label>
              <v-text-field
                hide-details="auto"
                v-model="currentSupplier.webSite"
                outlined
                class="primary-input"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="5" md="5" lg="5" class="pb-0">
              <label class="label">{{ $t('Estado') }}</label>
              <v-autocomplete
                hide-details="auto"
                v-model="currentSupplier.state"
                :rules="stateRules"
                :items="states"
                @change="getCities"
                :loading="statesLoading"
                outlined
                class="primary-input"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" class="pb-0">
              <label class="label">{{ $t('Cidade') }}</label>
              <v-autocomplete
                hide-details="auto"
                v-model="currentSupplier.city"
                :rules="cityRules"
                no-data-text="Selecione um estado"
                :items="cities"
                :loading="citiesLoading"
                outlined
                class="primary-input"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              sm="3"
              md="3"
              lg="3"
              class="d-flex align-center justify-center pb-0"
            >
              <label class="label"> {{ $t('Ativo') }} </label>
              <v-switch
                inset
                v-model="supplierStatus"
                @change="converterStatusToInt(supplierStatus)"
                :label="`${supplierStatus ? 'Sim' : 'Não'}`"
                color="#BBCF20"
                class="mx-4 label"
              >
              </v-switch>
            </v-col>
          </v-row>
          <v-row class="ma-0 mx-6" dense>
            <v-col cols="12" sm="10" md="10" lg="10">
              <span class="text--secondary">
                {{ $t('Informe seu CEP para preenchimento automático ou') }}
                <a
                  :style="inputDisabled ? 'color: #bbcf20' : 'color: #426483'"
                  @click="inputDisabled = !inputDisabled"
                  >{{ $t('preencher manualmente') }}</a
                >
              </span>
            </v-col>
            <v-col
              id="colLink"
              class="text-right"
              cols="12"
              sm="2"
              md="2"
              lg="2"
            >
              <a
                style="color: #bbcf20"
                href="https://buscacepinter.correios.com.br/app/endereco/index.php?t"
                target="_blank"
                >{{ $t('Não sei o CEP') }}</a
              >
            </v-col>
          </v-row>
          <v-row class="ma-0 mx-6" dense>
            <v-col cols="12" sm="5" md="5" lg="5" class="pb-0">
              <label class="label">{{ $t('CEP') }}</label>
              <v-text-field
                hide-details="auto"
                v-model="currentSupplier.cep"
                v-mask="['##.###-###']"
                @keyup="searchCEP"
                prepend-inner-icon="mdi-map-marker"
                required
                outlined
                class="primary-input"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="7" md="7" lg="7" class="pb-0">
              <label class="label">Logradouro</label>
              <v-text-field
                hide-details="auto"
                :disabled="inputDisabled"
                v-model="currentSupplier.address"
                :rules="addressRules"
                outlined
                class="primary-input"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="2" md="2" lg="2" class="pb-0">
              <label class="label">{{ $t('Número') }}</label>
              <v-text-field
                hide-details="auto"
                v-model="currentSupplier.locationNumber"
                outlined
                class="primary-input"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="5" md="5" lg="5" class="pb-0">
              <label class="label">{{ $t('Complemento (opcional)') }}</label>
              <v-text-field
                hide-details="auto"
                v-model="currentSupplier.complement"
                :rules="complementRules"
                outlined
                class="primary-input"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="5" md="5" lg="5" class="pb-0">
              <label class="label">{{ $t('Bairro') }}</label>
              <v-text-field
                hide-details="auto"
                :disabled="inputDisabled"
                v-model="currentSupplier.district"
                outlined
                class="primary-input"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-window-item>

      <v-window-item :value="1">
        <v-form
          class="form"
          ref="secondForm"
          v-model="secondValid"
          lazy-validation
        >
          <v-row class="ma-0 mx-6" dense>
            <v-col cols="12">
              <span class="detail-subtitle" style="font-size: 1rem">{{
                $t('Comercial')
              }}</span>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" class="py-0">
              <label class="label">{{ $t('Nome') }}</label>
              <v-text-field
                hide-details="auto"
                v-model="currentSupplier.businessContact"
                :rules="[
                  (v) =>
                    !v ||
                    v.length <= 128 ||
                    $t('Nome do contato deve ter no máximo 128 caracteres'),
                ]"
                outlined
                class="primary-input"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="6" class="py-0">
              <label class="label">E-mail</label>
              <v-text-field
                hide-details="auto"
                v-model="currentSupplier.businessEmail"
                :rules="emailRules"
                required
                outlined
                class="primary-input"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="6" class="pb-0">
              <label class="label">{{ $t('Telefone') }}</label>
              <v-text-field
                hide-details="auto"
                v-model="currentSupplier.businessPhoneNumber"
                :rules="phoneRules"
                v-mask="['(##) ####-####']"
                outlined
                class="primary-input"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="6" class="pb-0">
              <label class="label">{{ $t('Celular') }}</label>
              <v-text-field
                hide-details="auto"
                v-model="currentSupplier.businessCellPhoneNumber"
                :rules="cellPhoneRules"
                v-mask="['(##) #####-####']"
                outlined
                class="primary-input"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-divider></v-divider>

          <v-row class="ma-0 mx-6" dense>
            <v-col cols="12">
              <span class="detail-subtitle" style="font-size: 1rem">{{
                $t('Técnico')
              }}</span>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" class="py-0">
              <label class="label">{{ $t('Nome') }}</label>
              <v-text-field
                hide-details="auto"
                v-model="currentSupplier.technicalContact"
                :rules="[
                  (v) =>
                    !v ||
                    v.length <= 128 ||
                    'Nome do contato deve ter no máximo 128 caracteres',
                ]"
                outlined
                class="primary-input"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="6" class="py-0">
              <label class="label">{{ $t('E-mail') }}</label>
              <v-text-field
                hide-details="auto"
                v-model="currentSupplier.technicalEmail"
                :rules="emailRules"
                required
                outlined
                class="primary-input"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="6">
              <label class="label">{{ $t('Telefone') }}</label>
              <v-text-field
                hide-details="auto"
                v-model="currentSupplier.technicalPhoneNumber"
                :rules="phoneRules"
                v-mask="['(##) ####-####']"
                outlined
                class="primary-input"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="6">
              <label class="label">{{ $t('Celular') }}</label>
              <v-text-field
                hide-details="auto"
                v-model="currentSupplier.technicalCellPhoneNumber"
                :rules="cellPhoneRules"
                v-mask="['(##) #####-####']"
                outlined
                class="primary-input"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-window-item>

      <v-window-item :value="2">
        <v-form
          class="form"
          ref="thirdForm"
          v-model="thirdValid"
          lazy-validation
        >
          <v-row class="ma-0 mx-6" dense>
            <v-col cols="12" class="pb-0">
              <label class="label">{{ $t('Informações adicionais') }}</label>
              <v-textarea
                hide-details="auto"
                no-resize
                rows="3"
                v-model="currentSupplier.additionalInformation"
                outlined
                class="text-area-input"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-window-item>

      <v-window-item :value="3">
        <div class="fill-height text-center pa-8">
          <v-icon size="60" color="success">
            mdi-checkbox-marked-circle
          </v-icon>

          <span style="display: block; margin-top: 10px; font-size: 1.2rem">
            {{
              isEditing
                ? $t('Fornecedor atualizado com sucesso!')
                : $t('Fornecedor cadastrado com sucesso!')
            }}
          </span>
        </div>
      </v-window-item>
    </v-window>

    <v-divider class="mb-6 mt-2 mx-8"></v-divider>

    <div class="d-flex mx-6" v-if="!institutionInactive">
      <v-btn
        depressed
        @click="close"
        v-if="step === 0"
        class="secondary-button"
      >
        {{ $t('Cancelar') }}
      </v-btn>
      <v-btn
        depressed
        @click="back"
        :disabled="step === 3"
        v-if="step !== 0"
        color="grey"
        class="quaternary-button ml-4"
        text
      >
        {{ $t('Voltar') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        depressed
        class="primary-button mr-0"
        @click="next"
        :loading="loading"
      >
        {{ $t(buttonText) }}
      </v-btn>
    </div>
  </v-card>
</template>

<style scoped>
.v-application .primary--text {
  color: #707070 !important;
  caret-color: #707070 !important;
}

@media (max-width: 600px) {
  .v-card__text {
    padding: 0;
  }

  #colLink {
    text-align: start !important;
  }
}
</style>

<script>
import ApiService from '../../../../services/ApiService'
import InstitutionInactive from '../../Institutions/components/institutionInactive/institutionInactive.vue'

export default {
  props: {
    title: String,
    supplier: Object,
  },

  components: {
    InstitutionInactive,
  },

  created() {
    const institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = institution.id
    this.institutionInactive = institution.status == 1
    this.getStates()
    if (this.supplier) {
      this.currentSupplier = this.supplier
      this.supplierStatus = this.supplier.status == 0
      this.isEditing = true

      if (this.currentSupplier.state != null) {
        this.getCities()
      }

      if (this.currentSupplier.cep != null) {
        this.searchCEP()
      }
    }
  },

  data: () => ({
    step: 0,
    errorMessage: '',
    loading: false,
    citiesLoading: false,
    firstValid: true,
    secondValid: true,
    thirdValid: true,
    alterDialog: false,
    changedData: false,
    isEditing: false,
    inputDisabled: true,
    error: false,
    institutionInactive: false,
    institutionId: null,
    supplierStatus: true,
    states: [],
    cities: [],
    currentSupplier: {
      id: 0,
      name: '',
      corporateName: '',
      webSite: '',
      cnpj: '',
      cep: '',
      address: '',
      locationNumber: '',
      complement: '',
      district: '',
      city: '',
      state: '',
      businessContact: '',
      businessEmail: '',
      businessPhoneNumber: '',
      businessCellPhoneNumber: '',
      technicalContact: '',
      technicalEmail: '',
      technicalPhoneNumber: '',
      technicalCellPhoneNumber: '',
      additionalInformation: '',
      status: 0,
    },
    nameRules: [
      (v) => !!v || 'Fornecedor requerido',
      (v) =>
        (v && v.length <= 128) ||
        'Fornecedor deve ter no máximo 128 caracteres',
    ],
    corporateNameRules: [
      (v) => !!v || 'Razão social requerida',
      (v) =>
        (v && v.length <= 128) ||
        'Razão social deve ter no máximo 128 caracteres',
    ],
    stateRules: [(v) => !!v || 'Estado é requerido'],
    cityRules: [(v) => !!v || 'Cidade é requerida'],
    addressRules: [
      (v) =>
        !v || v.length <= 64 || 'Logradouro deve ter no máximo 64 caracteres',
    ],
    complementRules: [
      (v) =>
        !v || v.length <= 64 || 'Complemento deve ter no máximo 64 caracteres',
    ],
    districtRules: [
      (v) => !v || v.length <= 64 || 'Bairro deve ter no máximo 30 caracteres',
    ],
    emailRules: [(v) => !v || /.+@.+\..+/.test(v) || 'E-mail inválido'],
    phoneRules: [(v) => !v || v.length > 13 || 'Telefone inválido'],
    cellPhoneRules: [(v) => !v || v.length > 14 || 'Celular inválido'],

    apiService: new ApiService(),
  }),

  computed: {
    currentTitle() {
      switch (this.step) {
        case 0:
          return 'Dados Institucionais'
        case 1:
          return 'Contatos'
        case 2:
          return 'Adicionais'
        default:
          return this.isEditing ? 'Atualização efetuada' : 'Cadastro efetuado'
      }
    },

    buttonText() {
      switch (this.step) {
        case 0:
          return 'Continuar'
        case 1:
          return 'Continuar'
        case 2:
          return this.isEditing ? 'Atualizar' : 'Adicionar'
        default:
          return 'Terminar'
      }
    },
  },

  methods: {
    close() {
      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.$emit('close')
      }
    },

    closeDialog() {
      this.changedData = false
      this.close()
    },

    back() {
      this.step--
    },

    converterStatusToInt(status) {
      if (status) {
        this.currentSupplier.status = 0
      } else {
        this.currentSupplier.status = 1
      }
    },

    validarCNPJ(cnpj) {
      cnpj = cnpj.replace(/[^\d]+/g, '')

      if (cnpj == '') return false

      if (cnpj.length != 14) return false

      // Elimina CNPJs invalidos conhecidos
      if (
        cnpj == '00000000000000' ||
        cnpj == '11111111111111' ||
        cnpj == '22222222222222' ||
        cnpj == '33333333333333' ||
        cnpj == '44444444444444' ||
        cnpj == '55555555555555' ||
        cnpj == '66666666666666' ||
        cnpj == '77777777777777' ||
        cnpj == '88888888888888' ||
        cnpj == '99999999999999'
      )
        return false

      // Valida DVs
      let tamanho = cnpj.length - 2
      let numeros = cnpj.substring(0, tamanho)
      let digitos = cnpj.substring(tamanho)
      let soma = 0
      let pos = tamanho - 7
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--
        if (pos < 2) pos = 9
      }
      let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
      if (resultado != digitos.charAt(0)) return false

      tamanho = tamanho + 1
      numeros = cnpj.substring(0, tamanho)
      soma = 0
      pos = tamanho - 7
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--
        if (pos < 2) pos = 9
      }
      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
      if (resultado != digitos.charAt(1)) return false

      return true
    },

    async searchCEP() {
      if (this.inputDisabled) {
        const cep = this.currentSupplier.cep.replace(/[^0-9]/, '')

        if (cep.length < 9) {
          return
        }

        await this.apiService
          .get(`address/postalcode?cep=${cep}`)
          .then((response) => {
            const location = response.content
            this.currentSupplier.address = location.logradouro
            this.currentSupplier.district = location.bairro
          })
          .catch((err) => {
            this.errorMessage = err.body.message
            this.error = true
            this.currentSupplier.address = ''
            this.currentSupplier.district = ''

            setTimeout(() => {
              this.error = false
            }, 4000)
          })
      }
    },

    async getStates() {
      this.statesLoading = true

      await this.apiService
        .get('address/states')
        .then((response) => {
          this.states = response.content.map((uf) => uf.sigla).sort()
          this.statesLoading = false
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async getCities() {
      this.citiesLoading = true
      await this.apiService
        .get(`address/cities?state=${this.currentSupplier.state}`)
        .then((response) => {
          this.cities = response.content.map((city) => city.nome).sort()
          this.citiesLoading = false
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async next() {
      if (this.step === 0) {
        if (this.$refs.firstForm.validate()) {
          this.step++
        }
      } else if (this.step === 1) {
        if (this.$refs.secondForm.validate()) {
          this.step++
        }
      } else if (this.step === 2) {
        if (this.$refs.thirdForm.validate()) {
          this.submit()
        }
      } else {
        this.closeDialog()
      }
    },

    async submit() {
      this.loading = true

      const supplier = {
        Id: this.currentSupplier.id,
        InstitutionId: this.institutionId,
        Name: this.currentSupplier.name,
        CorporateName: this.currentSupplier.corporateName,
        Website: this.currentSupplier.webSite,
        Cnpj: this.currentSupplier.cnpj,
        Cep: this.currentSupplier.cep,
        Address: this.currentSupplier.address,
        LocationNumber: this.currentSupplier.locationNumber,
        Complement: this.currentSupplier.complement,
        District: this.currentSupplier.district,
        City: this.currentSupplier.city,
        State: this.currentSupplier.state,
        BusinessContact: this.currentSupplier.businessContact,
        BusinessEmail: this.currentSupplier.businessEmail,
        BusinessPhoneNumber: this.currentSupplier.businessPhoneNumber,
        BusinessCellPhoneNumber: this.currentSupplier.businessCellPhoneNumber,
        TechnicalContact: this.currentSupplier.technicalContact,
        TechnicalEmail: this.currentSupplier.technicalEmail,
        TechnicalPhoneNumber: this.currentSupplier.technicalPhoneNumber,
        TechnicalCellPhoneNumber: this.currentSupplier.technicalCellPhoneNumber,
        AdditionalInformation: this.currentSupplier.additionalInformation,
        Status: this.currentSupplier.status,
      }

      let url = 'supplier/add'

      if (this.isEditing) {
        url = 'supplier/edit'
      }

      await this.apiService
        .post(url, supplier)
        .then(() => {
          this.step++
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true
          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.loading = false
      this.changedData = false
    },
  },

  watch: {
    currentSupplier: {
      deep: true,
      handler() {
        this.changedData = true
      },
    },

    inputDisabled: {
      deep: true,
      handler() {
        if (this.inputDisabled) {
          this.searchCEP()
        }
      },
    },
  },
}
</script>
